module.exports = __webpack_public_path__ + "1e7fdce4165cbfd22c05f8d675f0f451.svg";